import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import type { RouteLocationNormalized } from 'vue-router';
import { useOrganizationValue } from '@/composables/use-organization';
import { PAGE } from '@/constants/common';
import { useLogger } from '@/composables/use-logger';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
  /* v8 ignore start -- SPA (ssr: false) では import.meta.server は静的に false となり true 分岐へ到達不能 */
  if (import.meta.server) return;
  /* v8 ignore stop */
  if (to.path.split('/').includes('auth')) return;

  const logger = useLogger();

  try {
    const organizationId = await useOrganizationValue();
    if (!organizationId) {
      // 止めると Cookie を書くグロナビ(layout)が mount されないため通す。API 送信側(mutator)が待機・拒否する
      logger.warn('[organization-guard] organizationId is undefined, skipping guard check');
      return;
    }

    const lastAccessOrganizationId = localStorage.getItem('lastAccessOrganizationId');
    localStorage.setItem('lastAccessOrganizationId', organizationId);

    // 組織が変更された場合、ファイル一覧（クエリパラメータなし）以外からはファイル一覧にリダイレクト
    // クエリパラメータ付きの場合は旧組織のフィルター条件が残るためリダイレクトが必要
    if (lastAccessOrganizationId && lastAccessOrganizationId !== organizationId) {
      if (to.path !== PAGE.FILE_LIST || Object.keys(to.query).length > 0) {
        return navigateTo({ path: PAGE.FILE_LIST });
      }
    }
  } catch (error) {
    logger.error({ error }, '[organization-guard] Organization guard check failed');
    if (to.path === PAGE.FILE_LIST) return;
    try {
      return await navigateTo({ path: PAGE.FILE_LIST });
    } catch (navError) {
      logger.error({ error: navError }, '[organization-guard] Recovery navigation also failed');
    }
  }
});
